var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgH1Icon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42465 3.18237H4.24239C3.65656 3.18237 3.18164 3.65729 3.18164 4.24313V7.42538C3.18164 8.01122 3.65656 8.48613 4.24239 8.48613H7.42465C8.01049 8.48613 8.4854 8.01122 8.4854 7.42538V4.24313C8.4854 3.65729 8.01049 3.18237 7.42465 3.18237Z",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2147 3.18237H18.0324C17.4466 3.18237 16.9717 3.65729 16.9717 4.24313V7.42538C16.9717 8.01122 17.4466 8.48613 18.0324 8.48613H21.2147C21.8005 8.48613 22.2754 8.01122 22.2754 7.42538V4.24313C22.2754 3.65729 21.8005 3.18237 21.2147 3.18237Z",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42465 16.9719H4.24239C3.65656 16.9719 3.18164 17.4468 3.18164 18.0327V21.2149C3.18164 21.8008 3.65656 22.2757 4.24239 22.2757H7.42465C8.01049 22.2757 8.4854 21.8008 8.4854 21.2149V18.0327C8.4854 17.4468 8.01049 16.9719 7.42465 16.9719Z",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2754 16.9719H19.0932C18.5305 16.9719 17.9909 17.1954 17.5931 17.5933C17.1952 17.9912 16.9717 18.5308 16.9717 19.0934V22.2757",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2754 22.2759V22.2859",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7286 7.42505V10.6073C12.7286 11.17 12.5051 11.7096 12.1072 12.1074C11.7093 12.5053 11.1697 12.7288 10.6071 12.7288H7.4248",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18164 12.729H3.19164",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7285 3.18237H12.7385",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7285 16.9719V16.9819",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9717 12.729H18.0324",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2754 12.729V12.739",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7285 22.2758V21.2151",
    stroke: "white",
    strokeWidth: 2.1215,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH1Icon);
export default __webpack_public_path__ + "static/media/h1Icon.8099a70356b35a6e813b74bc91caad24.svg";
export { ForwardRef as ReactComponent };